import { cabinSymbols } from './cabin.tsx'
import { chevronsSymbols } from './chevrons.tsx'
import { harbourSymbols } from './harbour.tsx'
import { shipSymbols } from './ship.tsx'
import { informationSymbols } from './information.tsx'
import { trashSymbols } from './trash.tsx'
import { plusMinusSymbols } from './plus-minus.tsx'

// Rendered once per widget. Icons reference these symbols with <use>, so the path data is not repeated per icon.
// Sized 0x0 rather than display:none, which stops some browsers from resolving references into it.
const sprite = (
  <svg width='0' height='0' style={{ position: 'absolute' }} aria-hidden='true' focusable='false'>
    {[
      ...cabinSymbols,
      ...chevronsSymbols,
      ...harbourSymbols,
      ...shipSymbols,
      ...informationSymbols,
      ...trashSymbols,
      ...plusMinusSymbols
    ]}
  </svg>
)

// A constant element, so React skips diffing the symbols when the app re-renders
export function IconSprite (): JSX.Element {
  return sprite
}
